import { Link, useRouterState } from "@tanstack/react-router";
import { House, Grid2x2, CircleUserRound } from "lucide-react";

const navItems = [
  { to: "/", label: "Home", icon: House, exact: true, match: (p: string) => p === "/" },
  { to: "/shop", label: "Categories", icon: Grid2x2, exact: false, match: (p: string) => p.startsWith("/shop") },
  { to: "/account", label: "Account", icon: CircleUserRound, exact: false, match: (p: string) => p.startsWith("/account") || p.startsWith("/auth") },
] as const;

export function MobileBottomNav() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  if (pathname.startsWith("/admin")) return null;

  return (
    <>
      <div className="h-16 md:hidden" aria-hidden />
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
        <ul className="grid grid-cols-3">
          {navItems.map((it) => {
            const active = it.match(pathname);
            const Icon = it.icon;
            const isHome = it.to === "/";
            return (
              <li key={it.to}>
                <Link
                  to={it.to}
                  activeOptions={{ exact: it.exact }}
                  resetScroll
                  className="flex w-full flex-col items-center justify-center gap-1 py-2 text-[11px] text-muted-foreground"
                >
                  <span
                    className={`flex h-8 w-12 items-center justify-center rounded-2xl transition-colors ${
                      active ? "bg-muted text-foreground" : ""
                    }`}
                  >
                    <Icon className="h-5 w-5" strokeWidth={active ? 2.25 : 1.75} />
                  </span>
                  <span className={active ? "text-foreground font-medium" : ""}>{it.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  );
}
